// LOT 79 · « quelqu'un tape ou touche l'écran » : les relectures de fond (couleurs, nuit) attendent 1 s de calme
let geste = 0;
if (typeof window !== 'undefined') ['keydown', 'input', 'pointerdown', 'touchstart'].forEach((n) => window.addEventListener(n, () => { geste = performance.now(); }, { capture: true, passive: true }));
export const enGeste = () => performance.now() - geste < 1000;
